import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './Section';
import { CTAButton } from '../CTAButton';
export function Guarantee() {
  return <Section tone="white" data-id="element-147" data-mp="20j8pzzpcli4g">
      <div className="rounded-3xl border border-navy/10 bg-cream p-6 text-center sm:p-8" data-id="element-148" data-mp="24moluttlfeg3">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-navy" data-id="element-149" data-mp="29dolw7y0ecmt">
          <ShieldCheckIcon className="h-8 w-8 text-gold" data-id="element-150" data-mp="2ed9rv2bljl91" />
        </span>
        <h2 className="mt-4 font-display text-[1.6rem] font-bold leading-tight text-navy sm:text-3xl" data-id="element-151" data-mp="2efdvrk9hwk9b">
          Your Investment Is Completely Risk-Free
        </h2>
        <p className="mt-2 text-[12px] font-bold uppercase tracking-[0.18em] text-gold-dark" data-id="element-152" data-mp="2ocihxk3ccfq4">
          7-Day Money-Back Guarantee
        </p>
        <p className="mt-4 text-[14.5px] leading-relaxed text-navy/70" data-id="element-153" data-mp="tx692hnr5oqh">
          Go through the material. Review the clinical algorithms. Use the
          templates. Apply the protocols.
        </p>
        <p className="mt-3 text-[14.5px] leading-relaxed text-navy/70" data-id="element-154" data-mp="3slgazka67j0i">
          If, within the next 7 days, you don't feel the Menopause Clinical
          Blueprint™ helps you make faster, more confident clinical decisions,
          simply contact our support team. We'll refund 100% of your purchase.
        </p>
        <p className="mt-4 font-display text-lg font-bold text-navy" data-id="element-155" data-mp="3dx2859cr7ujy">
          No complicated forms. No questions asked. No risk.
        </p>
      </div>

      <CTAButton className="mt-8" variant="navy" label="Try it risk-free for 7 days" subline="100% refund if it's not for you" data-id="element-156" data-mp="fcu0nclwsjm5" />
    </Section>;
}